module.exports = __webpack_public_path__ + "static/media/MHRP29N0006.29f4da24.svg";